"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleSundayBefore = exports.default = void 0;
var _default2 = _interopRequireDefault(require("../default"));
var getValueByPath = function getValueByPath(locale, path) {
  var pathArray = path.split('.');
  var currentLocale = locale || _default2.default;
  for (var i = 0; i < pathArray.length; i++) {
    var property = pathArray[i];
    var value = currentLocale[property];
    if (!value) return '';
    if (i === pathArray.length - 1) return value;
    currentLocale = value;
  }
  return '';
};
var setLocale = function setLocale(locale) {
  var t = function t(path, options) {
    var result = getValueByPath(locale, path);
    if (!options) return result;
    // 查找所有花括号单词{word}替换为一个提供的options对象中对应键key的值，options没有找到对应的键则保留原来的花括号和键的格式
    return result.replace(/\{(\w+)\}/g, function (_, key) {
      return "".concat(options[key] === undefined || options[key] === null ? "{".concat(key, "}") : options[key]);
    });
  };
  return {
    t: t
  };
};
var handleSundayBefore = exports.handleSundayBefore = function handleSundayBefore(weekStartDay) {
  if (!weekStartDay) {
    return false;
  }
  return weekStartDay === 0;
};
var _default = exports.default = setLocale;